import { getClassName } from '@perpay-web/utils/domUtils';

import styles from './Inline.scss';

/**
 * The Inline component is a "layout primitive."
 * It is responsible for the following behaviors:
 * - Wrapping elements into a flex display context with a row flow
 * - Giving the same margin of 0 for all first-level children.
 * - Specifying sane defaults for rendering as a child of a flex context
 *
 * When would I use an Inline over a raw div?
 * - When I want the above behaviors
 * - When I want to composably style children in a column with simple layout
 *
 * When would I not use an Inline over a raw div?
 * - When I want to do more complex styling that does not fit into the above buckets
 *
 * Example usage:
 * ```
 * // MyComponent.js
 * <Inline className={styles['my-component']}>
 *   <CoolComponent />
 *   <CoolComponent />
 * </Inline>
 *
 * // MyComponent.scss
 * .my-component {
 *   composes: inline--gap__public from '~@perpay-web/components/design-system/Inline/Inline.scss';
 *   --inline-gap: #{$xs-space};
 * }
 * ```
 */
const Inline = ({ className = '', children }) => (
    <div className={getClassName(styles.inline, className)}>{children}</div>
);

export default Inline;
